import { makeStyles } from "@material-ui/core";

export const usePrivacyAndSafetyStyles = makeStyles(() => ({
    listWrapper: {
        paddingBottom: 64
    }
}));
